import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, BookOpen, Users, Lock } from "lucide-react";

export const PathsSection = () => {
  return (
    <section className="py-24 bg-slate-50" data-testid="paths-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold tracking-widest text-teal-700 uppercase">What We Offer</span>
          <h2 className="text-4xl font-bold text-slate-800 mt-4">Choose Your Path</h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-terracotta/20 rounded-3xl overflow-hidden" data-testid="women-path-card">
            <CardHeader className="bg-gradient-to-br from-terracotta/5 to-terracotta/10 p-6">
              <div className="w-14 h-14 bg-terracotta/20 rounded-2xl flex items-center justify-center mb-3">
                <Briefcase className="w-7 h-7 text-terracotta" />
              </div>
              <CardTitle className="text-xl text-slate-800">Educated Unemployed</CardTitle>
              <CardDescription className="text-sm text-slate-600">
                Skilled women seeking employment or self-employment opportunities
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6 pt-4">
              <Link to="/register?type=woman" className="block">
                <Button className="w-full bg-terracotta hover:bg-terracotta/90 rounded-full" data-testid="register-woman-btn">
                  Register
                </Button>
              </Link>
            </CardContent>
          </Card>
          
          <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-teal-500/20 rounded-3xl overflow-hidden" data-testid="girls-path-card">
            <CardHeader className="bg-gradient-to-br from-teal-500/5 to-teal-500/10 p-6">
              <div className="w-14 h-14 bg-teal-500/20 rounded-2xl flex items-center justify-center mb-3">
                <BookOpen className="w-7 h-7 text-teal-600" />
              </div>
              <CardTitle className="text-xl text-slate-800">Dropout</CardTitle>
              <CardDescription className="text-sm text-slate-600">
                Access quality home schooling and online education
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6 pt-4">
              <Link to="/register?type=girl" className="block">
                <Button className="w-full bg-teal-600 hover:bg-teal-700 rounded-full" data-testid="register-girl-btn">
                  Register
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-purple-500/20 rounded-3xl overflow-hidden" data-testid="general-path-card">
            <CardHeader className="bg-gradient-to-br from-purple-500/5 to-purple-500/10 p-6">
              <div className="w-14 h-14 bg-purple-500/20 rounded-2xl flex items-center justify-center mb-3">
                <Users className="w-7 h-7 text-purple-600" />
              </div>
              <CardTitle className="text-xl text-slate-800">General</CardTitle>
              <CardDescription className="text-sm text-slate-600">
                Community member access
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6 pt-4">
              <Link to="/register?type=general" className="block">
                <Button className="w-full bg-purple-600 hover:bg-purple-700 rounded-full" data-testid="register-general-btn">
                  Register
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-amber-500/20 rounded-3xl overflow-hidden" data-testid="admin-path-card">
            <CardHeader className="bg-gradient-to-br from-amber-500/5 to-amber-500/10 p-6">
              <div className="w-14 h-14 bg-amber-500/20 rounded-2xl flex items-center justify-center mb-3">
                <Lock className="w-7 h-7 text-amber-600" />
              </div>
              <CardTitle className="text-xl text-slate-800">Admin/Co-Admin</CardTitle>
              <CardDescription className="text-sm text-slate-600">
                Staff login portal
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6 pt-4">
              <Link to="/login" className="block">
                <Button className="w-full bg-amber-600 hover:bg-amber-700 rounded-full" data-testid="admin-login-btn">
                  Login
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default PathsSection;
